import React from 'react';

const PublicPanelIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="20" cy="20" r="20" fill="var(--icon-public-bg)" />
        <path d="M20 28.3333C24.6024 28.3333 28.3333 24.6024 28.3333 20C28.3333 15.3976 24.6024 11.6667 20 11.6667C15.3976 11.6667 11.6667 15.3976 11.6667 20C11.6667 24.6024 15.3976 28.3333 20 28.3333Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6667 20H28.3333" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 11.6667C22.0844 13.9486 23.269 16.91 23.3333 20C23.269 23.09 22.0844 26.0514 20 28.3333C17.9156 26.0514 16.731 23.09 16.6667 20C16.731 16.91 17.9156 13.9486 20 11.6667Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="29" cy="11" r="1" fill="white" />
        <circle cx="15.5" cy="8" r="1" fill="var(--icon-public-bg)" />
        <circle cx="18" cy="32.5" r="1" fill="var(--COTI-v2-supporting-primary-blue-200)" />
        <circle cx="7" cy="21" r="1" fill="var(--COTI-v2-brand-secondary-green)" />
        <circle cx="31" cy="26" r="1" fill="var(--COTI-v2-brand-secondary-light-green)" />
    </svg>
);

export default PublicPanelIcon;
